import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7071 10.2929C11.3166 9.90237 10.6834 9.90237 10.2929 10.2929C9.90237 10.6834 9.90237 11.3166 10.2929 11.7071L11 11L11.7071 10.2929ZM15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L16 16L15.2929 16.7071ZM6.83333 12.6667V11.6667C4.16396 11.6667 2 9.50271 2 6.83333H1H0C0 10.6073 3.05939 13.6667 6.83333 13.6667V12.6667ZM1 6.83333H2C2 4.16396 4.16396 2 6.83333 2V1V0C3.05939 0 0 3.05939 0 6.83333H1ZM6.83333 1V2C9.50271 2 11.6667 4.16396 11.6667 6.83333H12.6667H13.6667C13.6667 3.05939 10.6073 0 6.83333 0V1ZM12.6667 6.83333H11.6667C11.6667 9.50271 9.50271 11.6667 6.83333 11.6667V12.6667V13.6667C10.6073 13.6667 13.6667 10.6073 13.6667 6.83333H12.6667ZM11 11L10.2929 11.7071L15.2929 16.7071L16 16L16.7071 15.2929L11.7071 10.2929L11 11Z",
		fill: "#66798D"
	})
});
export default SvgSearch;
